const initialState = {
  pageLoader: true,
  onDemandAdsData: null,
  onDemandAdsListWithPagination: {
    limit: 30,
    page: 0,
    total_pages: null,
    total_records: null,
    data: null,
  },
};

const onDemandAds = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ON_DEMAND_ADS_DATA":
      return { ...state, onDemandAdsData: action.data };
    case "GET_ALL_ON_DEMAND_ADS":
      return {
        ...state,
        onDemandAdsListWithPagination: action.data,
        pageLoader: false,
      };
    case "GET_ON_DEMAND_ADS_DATA":
      return { ...state, onDemandAdsData: action.data };
    case "PAGE_LOADER":
      return { ...state, pageLoader: action.data };
    case "DELETE_ON_DEMAND_ADS_DATA":
      return { ...state, pageLoader: false };
    default:
      return { ...state };
  }
};

export default onDemandAds;
